export default __webpack_public_path__ + "static/media/world2doortext.9d343e14.png";